import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Importar dados de localização para português
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

// Registrar dados de localização
registerLocaleData(localePt, 'pt');

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
